<script lang="ts">
  import { UsersTexts } from '../../UsersTexts';
  import * as Icons from '@lucide/svelte';
  import Box from '../../../../components/boxes/Box.svelte';
  import Content from '../../../../components/content/Content.svelte';
  import FormButton from '../../../../components/forms/FormButton.svelte';
  import FormButtonLine from '../../../../components/forms/FormButtonLine.svelte';
  import ChangePasswordBox from './ChangePasswordBox.svelte';
  import { ApiService } from '../../../../api/services/ApiService';
  import { PageService } from '../../../../services/PageService.svelte';
  import { UserService } from '../../../../services/UserService.svelte';

  // - logged in, but not in the team USER yet (a new registration): only the password and the logout are open (ApiOnlyLogin)
  let IsPasswordOpen = $state(false);
  let IsLoggingOut = $state(false);

  function logout(): void {
    IsLoggingOut = true;
    void ApiService.users.logout().then(async (): Promise<void> => {
      await UserService.refresh();
      PageService.set('/');
    });
  }
</script>

<Box layerAbs={true} lightDarker={true}>
  {#snippet headline()}{UsersTexts.AccountPending}{/snippet}
  <Content>
    <p>{UsersTexts.format(UsersTexts.PendingGreeting, { name: UserService.displayName })}</p>
    <p>{UsersTexts.PendingHint}</p>
  </Content>
  <FormButtonLine>
    <FormButton
      icon={Icons.KeyRound}
      state="gray"
      onclick={(): void => {
        IsPasswordOpen = !IsPasswordOpen;
      }}>{UsersTexts.PasswordChange}</FormButton>
    <FormButton icon={Icons.LogOut} state="warning" disabled={IsLoggingOut} onclick={logout}>{UsersTexts.Logout}</FormButton>
  </FormButtonLine>
</Box>

{#if IsPasswordOpen}
  <ChangePasswordBox />
{/if}
